/* eslint-disable react/no-array-index-key */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import HomePageBlocks from './HomePageBlocks';

import styles from '../../styles/pages/home-page-quatre95.module.css';

const propTypes = {
    brand: AppPropTypes.brand.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};
function HomePageQuatre95({ brand, className, ...props }) {
    return (
        <HomePageBlocks
            {...props}
            brand={brand}
            className={classNames([styles.container, className])}
            blocksClassName={styles.blocks}
        />
    );
}

HomePageQuatre95.propTypes = propTypes;
HomePageQuatre95.defaultProps = defaultProps;

export default HomePageQuatre95;
